import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { PageHeader } from './PageHeader';
import { PAGE_BODY, PAGE_SHELL } from './pageChrome';

/**
 * Shared staff page shell. Owns Designmanual V2 content padding
 * (desktop 24/32/48, mobile 16/16/32) and the title row so every
 * top-level page starts content at the same y.
 */
export function PageLayout({
  title,
  subtitle,
  actions,
  toolbar,
  fill = false,
  className,
  contentClassName,
  children,
}: {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  toolbar?: ReactNode;
  fill?: boolean;
  className?: string;
  contentClassName?: string;
  children?: ReactNode;
}) {
  const hasHeader = title != null;
  return (
    <div
      className={cn(
        PAGE_SHELL,
        fill && 'flex min-h-0 flex-1 flex-col overflow-hidden',
        className,
      )}
    >
      {hasHeader ? (
        <PageHeader title={title} subtitle={subtitle} actions={actions} toolbar={toolbar} />
      ) : null}
      {children != null ? (
        <div
          className={cn(
            hasHeader && PAGE_BODY,
            fill && 'flex min-h-0 flex-1 flex-col',
            contentClassName,
          )}
        >
          {children}
        </div>
      ) : null}
    </div>
  );
}
